import { useMsal } from '@azure/msal-react';
import { isDevAuthBypass } from '../auth/index';

export interface EntraIdentity {
  email: string;
  name: string;
  initials: string;
}

/** Reads the active MSAL account's claims. Returns null when not signed in.
 * Dev bypass: mirrors the API's requireCdxUser bypass identity (dev@claridynamics.com "Local Dev")
 * so claim ownership (claimedByMe / the hard-lock UX) behaves in the local demo exactly as it does
 * in production, where MSAL supplies the same identity to both sides. */
export function useEntraIdentity(): EntraIdentity | null {
  const { instance } = useMsal();
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? null;
  if (!account) {
    if (isDevAuthBypass()) {
      return { email: 'dev@claridynamics.com', name: 'Local Dev', initials: 'LD' };
    }
    return null;
  }
  const email = (account.username ?? '').toLowerCase();
  const name = account.name ?? account.username ?? email;
  return { email, name, initials: initialsOf(name) };
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}
